import React from 'react';
import { Note } from '@/store/notesStore';
import NoteListRow from './NoteListRow';

interface NotesListProps {
  notes: Note[];
  searchQuery?: string;
}

const NotesList: React.FC<NotesListProps> = ({ notes, searchQuery }) => {
  return (
    <div className="flex flex-col gap-1 max-w-3xl mx-auto w-full">
      {notes.map((note) => (
        <NoteListRow key={note.id} note={note} searchQuery={searchQuery} />
      ))}
    </div>
  );
};

export default NotesList;
